import React, { useEffect, useState } from "react";
import { Spinner, Form, Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

const SelectGenrateInvoice = () => {
  const navigate = useNavigate();

  // Data Lists
  const [recordList, setRecordsList] = useState([]); // Income Types
  const [categories, setCategories] = useState([]);
  const [grades, setGrades] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // UI State
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);

  // Form State
  const [formData, setFormData] = useState({
    category: "",
    incomeType: "",
    grade: "",
    academicYear: "",
    wallet_bal: false,
  });

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [studentValues, setStudentValues] = useState({}); // Stores amount/discount/bonus per student
  const [errors, setErrors] = useState({}); // Form errors

  const [studentErrors, setStudentErrors] = useState({});

  /* ---------------- API CALLS ---------------- */

  const fetchInitialData = async () => {
    const commonBody = JSON.stringify({
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      language: "en",
    });

    try {
      // Fetch Income Types
      const incomeRes = await simplePostCall(
        ApiConfig.incomeTypeList,
        JSON.stringify({
          ...JSON.parse(commonBody),
          user_id: Number(localStorage.getItem("user_id")),
          page: 1,
          limit: 9999,
        }),
      );
      if (incomeRes?.result) setRecordsList(incomeRes.data || []);

      // Fetch Categories
      const catRes = await simplePostCall(ApiConfig.categorytype, commonBody);
      if (catRes?.fee_category) setCategories(catRes.fee_category);

      // Fetch Grades
      const gradeRes = await simplePostCall(ApiConfig.classlist, commonBody);
      if (gradeRes?.classread) setGrades(gradeRes.classread);

      // Fetch Academic Years
      const yearRes = await simplePostCall(ApiConfig.academicyear, commonBody);
      if (yearRes?.academicYear) setAcademicYears(yearRes.academicYear);
    } catch (err) {
      console.error("Initialization failed", err);
    }
  };

  const fetchStudentsByGrade = async (gradeId) => {
    if (!gradeId) return;
    setIsTableLoading(true);
    try {
      const res = await simplePostCall(
        ApiConfig.Studentclasslist,
        JSON.stringify({
          customer_id: Number(localStorage.getItem("customer_id")),
          api_key: localStorage.getItem("api_key"),
          class_id: gradeId,
        }),
      );
      setStudentList(res?.academicYear || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  /* ---------------- HANDLERS ---------------- */

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setFormData((prev) => ({ ...prev, [name]: val }));

    // Remove error instantly when user selects value
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (val !== "" && updatedErrors[name]) {
        delete updatedErrors[name];
      }

      return updatedErrors;
    });

    if (name === "grade") {
      fetchStudentsByGrade(value);

      // Reset selection when grade changes
      setSelectedStudents([]);
      setStudentErrors({});
    }
  };

  const handleStudentValueChange = (studentId, field, value) => {
    // Update value
    setStudentValues((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [field]: value,
      },
    }));

    // 🔥 Remove error instantly when user types valid value
    setStudentErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      const numericValue = Number(value);

      if (value !== "" && !isNaN(numericValue) && numericValue > 0) {
        if (updatedErrors[studentId]) {
          delete updatedErrors[studentId][field];

          // remove empty object
          if (Object.keys(updatedErrors[studentId]).length === 0) {
            delete updatedErrors[studentId];
          }
        }
      }

      return updatedErrors;
    });
  };

  const toggleStudentSelection = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId],
    );
  };

  // Select All Logic
  const handleSelectAll = (e) => {
 

      const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (e.target.checked) {
      setSelectedStudents(studentList.map((s) => s.student_id));
    } else {
      setSelectedStudents([]);
      setStudentErrors({}); // Clear all student validation errors
    }
  };

  /* ---------------- VALIDATION ---------------- */
  const validateForm = () => {
    let tempErrors = {};
    let tempStudentErrors = {};

    if (!formData.category) tempErrors.category = "Category is required";
    if (!formData.incomeType) tempErrors.incomeType = "Income Type is required";
    if (!formData.grade) tempErrors.grade = "Grade is required";
    if (!formData.academicYear)
      tempErrors.academicYear = "Academic Year is required";
    if (selectedStudents.length === 0)
      tempErrors.students = "Select at least one student";

    //  Student table validation
    selectedStudents.forEach((id) => {
      const rawAmount = studentValues[id]?.amount;
      const rawDiscount = studentValues[id]?.discount;
      const rawBonus = studentValues[id]?.bonus;

      const amount = Number(rawAmount);
      const discount = Number(rawDiscount);
      const bonus = Number(rawBonus);

      tempStudentErrors[id] = {};

      // Amount validation
      if (rawAmount === undefined || rawAmount === "" || amount <= 0) {
        tempStudentErrors[id].amount = "Amount must be greater than 0";
      }

      // Discount validation
      // if (rawDiscount === undefined || rawDiscount === "" || discount <= 0) {
      //   tempStudentErrors[id].discount = "Discount must be greater than 0";
      // } else if (discount > amount) {
      //   tempStudentErrors[id].discount = "Discount cannot exceed amount";
      // }

      // Bonus validation
      // if (rawBonus === undefined || rawBonus === "" || bonus <= 0) {
      //   tempStudentErrors[id].bonus = "Bonus must be greater than 0";
      // }

      if (Object.keys(tempStudentErrors[id]).length === 0) {
        delete tempStudentErrors[id];
      }
    });

    setErrors(tempErrors);
    setStudentErrors(tempStudentErrors);

    return (
      Object.keys(tempErrors).length === 0 &&
      Object.keys(tempStudentErrors).length === 0
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!formData.grade || selectedStudents.length === 0) {
    //   toast.error("Please select a grade and at least one student.");
    //   return;
    // }

    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }

    setIsLoading(true);
    const payload = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: localStorage.getItem("user_id"),
      category: [Number(formData.category)],
      class_id: formData.grade,
      accademic: formData.academicYear,
      wallet_bal: formData.wallet_bal ? "on" : "off",
      students: selectedStudents,
      student_data: selectedStudents.map((id) => ({
        id,
        amount: studentValues[id]?.amount || 0,
        discount: studentValues[id]?.discount || 0,
        bonus: studentValues[id]?.bonus || 0,
      })),
    };

    try {
      const res = await simplePostCall(
        ApiConfig.Yselectedinvoice,
        JSON.stringify(payload),
      );
      if (res?.result) {
        toast.success("Invoices generated successfully!");

        setTimeout(() => {
          navigate("/UpcomingInvoices");
        }, 2000);
      } else {
        toast.error(res?.message || "Submit failed");
      }
    } catch (err) {
      toast.error("An error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="SelectStudent-container my-4">
      <ToastContainer />
      <div className="container-fluid bg-white shadow-sm py-3 px-4 mb-3 rounded">
        <h4>Generate Invoice</h4>
      </div>

      <div className="SelectStudent-invoice-form mt-3 bg-white p-4 shadow-sm rounded">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-4">
            <Col md={6} className="mb-3">
              <Form.Label>
                Select Category <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                isInvalid={!!errors.category}
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.fee_category_id} value={cat.fee_category_id}>
                    {cat.fee_category_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.category}
              </Form.Control.Feedback>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label>
                Select Income Type <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="incomeType"
                value={formData.incomeType}
                onChange={handleInputChange}
                isInvalid={!!errors.incomeType}
              >
                <option value="">Select Type</option>
                {recordList.map((record) => (
                  <option
                    key={record.income_type_id}
                    value={record.income_type_id}
                  >
                    {record.income_type_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.incomeType}
              </Form.Control.Feedback>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label>
                Select Grade <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="grade"
                value={formData.grade}
                onChange={handleInputChange}
                isInvalid={!!errors.grade}
              >
                <option value="">Select Grade</option>
                {grades.map((g) => (
                  <option key={g.class_id} value={g.class_id}>
                    {g.class_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.grade}
              </Form.Control.Feedback>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label>
                Select Academic Year <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="academicYear"
                value={formData.academicYear}
                onChange={handleInputChange}
                isInvalid={!!errors.academicYear}
              >
                <option value="">Select Academic Year</option>
                {academicYears.map((y) => (
                  <option key={y.academic_year_id} value={y.academic_year_id}>
                    {y.academic_year_name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.academicYear}
              </Form.Control.Feedback>
            </Col>

            <Col md={12}>
              <Form.Check
                type="checkbox"
                name="wallet_bal"
                label="Collect amount from student wallet"
                checked={formData.wallet_bal}
                onChange={handleInputChange}
              />
            </Col>
          </Row>

          <div className="student-table-wrapper mt-4">
            {isTableLoading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : studentList.length > 0 ? (
              <>
                <Table
                  responsive
                  striped
                  bordered
                  hover
                  className="align-middle"
                >
                  <thead className="table-light">
                    <tr>
                      <th>
                        <Form.Check
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            studentList.length > 0 &&
                            selectedStudents.length === studentList.length
                          }
                        />
                      </th>
                      <th>Students</th>
                      <th>Amount</th>
                      <th>Discount</th>
                      <th>Bonus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentList.map((student) => (
                      <tr key={student.student_id}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            checked={selectedStudents.includes(
                              student.student_id,
                            )}
                            onChange={() =>
                              toggleStudentSelection(student.student_id)
                            }
                          />
                        </td>
                        <td>{student.student_name}</td>
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="0"
                            value={
                              studentValues[student.student_id]?.amount || ""
                            }
                            isInvalid={
                              !!studentErrors[student.student_id]?.amount
                            }
                            onChange={(e) =>
                              handleStudentValueChange(
                                student.student_id,
                                "amount",
                                e.target.value,
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {studentErrors[student.student_id]?.amount}
                          </Form.Control.Feedback>
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="0"
                            value={
                              studentValues[student.student_id]?.discount || ""
                            }
                            isInvalid={
                              !!studentErrors[student.student_id]?.discount
                            }
                            onChange={(e) =>
                              handleStudentValueChange(
                                student.student_id,
                                "discount",
                                e.target.value,
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {studentErrors[student.student_id]?.discount}
                          </Form.Control.Feedback>
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="0"
                            value={
                              studentValues[student.student_id]?.bonus || ""
                            }
                            isInvalid={
                              !!studentErrors[student.student_id]?.bonus
                            }
                            onChange={(e) =>
                              handleStudentValueChange(
                                student.student_id,
                                "bonus",
                                e.target.value,
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {studentErrors[student.student_id]?.bonus}
                          </Form.Control.Feedback>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {errors.students && (
                  <div className="text-danger mt-2">{errors.students}</div>
                )}
              </>
            ) : (
              <div className="text-center py-3 text-muted">
                No students found. Please select a grade.
              </div>
            )}
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              type="submit"
              className="btn btn-primary px-5"
              disabled={isLoading}
            >
              {isLoading ? <Spinner size="sm" /> : "Submit"}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SelectGenrateInvoice;
